import { IMemberSpecificGroups } from "../types/idol";
export const memberSpecifics: IMemberSpecificGroups = {
  THEBOYZ: {
    members: {
      상연: {
        name: "이상연 (李上淵, Lee Sangyeon)",
        englishName: "Sangyeon",
        imgs: [
          "https://i.ibb.co/8zsptDy/theboyz-sy-slide1.png",
          "https://i.ibb.co/MnHFqCn/theboyz-sy-slide2.png",
          "https://i.ibb.co/VtHW4k4/theboyz-sy-slide3.png",
        ],
        birth: ["1996년 11월 04일", "서울특별시 송파구 가락동"],
        nationality: "대한민국",
        physical: "176cm | 61kg | 260mm | A형",
        familys: ["아버지(어렸을 때 별세), 어머니, 누나(1988년생)"],
        academics: [
          "서울가동초등학교 (졸업)",
          "송파중학교 (졸업)",
          "문정고등학교 (전학)",
          "리라아트고등학교 (디지털사운드콘텐츠과 / 전학)",
          "한림연예예술고등학교 (연예과 / 졸업)",
        ],
        religion: "가톨릭 (세례명: 도비야)",
        agency: "원헌드레드레이블",
        groupName: "더보이즈",
        position: "반장, 메인보컬",
        debut: "2017년 더보이즈 미니 1집 THE FIRST",
        mbti: "ENTP",
        serialNumber: "82",
      },
      제이콥: {
        name: ["Jacob Bae (제이콥 배)", "배준영 (裵俊英, Bae Junyung)"],
        englishName: "Jacob Bae",
        imgs: [
          "https://i.ibb.co/C9gQt1h/theboyz-jacob-slide1.png",
          "https://i.ibb.co/ypxPQM3/theboyz-jacob-slide2.png",
          "https://i.ibb.co/qRwn6yg/theboyz-jacob-slide3.png",
        ],
        birth: ["1997년 5월 30일", "캐나다 온타리오 토론토"],
        nationality: "캐나다",
        physical: "179cm | 60kg | 270mm | B형",
        familys: ["부모님,형(1995년생)", "반려견 럭키, 덱스터, 코비, 헤일로"],
        academics: ["Stephen Lewis Secondary School (졸업)"],
        religion: "개신교",
        agency: "원헌드레드레이블",
        groupName: "더보이즈",
        position: "부반장, 리드보컬",
        debut: "2017년 더보이즈 미니 1집 THE FIRST",
        mbti: "INFP",
        serialNumber: "30",
      },
      영훈: {
        name: "김영훈 (金泳勳, Kim Younghoon)",
        englishName: "Younghoon",
        imgs: [
          "https://i.ibb.co/0JzWsB6/theboyz-yh-slide1.png",
          "https://i.ibb.co/DpGhmVF/theboyz-yh-slide2.png",
          "https://i.ibb.co/PCwgzcq/theboyz-yh-slide3.png",
        ],
        birth: ["1997년 8월 8일", "서울특별시 양천구 목동"],
        nationality: "대한민국",
        physical: "185cm | 61~63kg | 265~270mm | A형",
        familys: ["부모님(1967년생), 형(1993년생)", "반려견 보리(♀, 푸들)"],
        academics: [
          "인천연성초등학교 (졸업)",
          "연성중학교 (졸업)",
          "인천연송고등학교 (졸업)",
        ],
        religion: "무종교",
        agency: "원헌드레드레이블",
        groupName: "더보이즈",
        position: "서브보컬",
        debut: "2017년 더보이즈 미니 1집 THE FIRST",
        mbti: "INFP",
        serialNumber: "67",
      },
      현재: {
        name: "이재현 (李在賢, Lee Jaehyun)",
        englishName: "HYUNJAE",
        imgs: [
          "https://i.ibb.co/CV925MM/theboyz-hj-slide3.png",
          "https://i.ibb.co/sQKdPWZ/theboyz-hj-slide2.png",
          "https://i.ibb.co/MGM12PN/theboyz-hj-slide1.png",
        ],
        birth: ["1997년 9월 13일", "인천광역시 연수구 동춘동"],
        nationality: "대한민국",
        physical: "180cm | 66kg | 265~270mm | B형",
        familys: [
          "아버지(1970년생), 어머니, 누나(1994년생)",
          "반려견 다롱이(♂, 시츄)",
        ],
        academics: [
          "인천먼우금초등학교 (졸업)",
          "신송중학교 (졸업)",
          "신송고등학교 (전학)",
          "한림연예예술고등학교 (뮤지컬과 / 졸업)",
        ],
        religion: "무종교",
        agency: "원헌드레드레이블",
        groupName: "더보이즈",
        position: "리드보컬",
        debut: "2017년 더보이즈 미니 1집 THE FIRST",
        mbti: "ESTP",
        serialNumber: "24",
      },
      주연: {
        name: "이주연 (李柱延, Lee Juyeon)",
        englishName: "Juyeon",
        imgs: [
          "https://i.ibb.co/8rLQ671/theboyz-jy-slide1.png",
          "https://i.ibb.co/TWR9LBM/theboyz-jy-slide2.png",
          "https://i.ibb.co/fdGDp2w/theboyz-jy-slide3.png",
        ],
        birth: ["1998년 1월 15일", "경기도 광주군 초월면"],
        nationality: "대한민국",
        physical: "180.4cm | 66kg | 270mm | AB형",
        familys: [
          "아버지, 어머니(1967년생), 남동생(2002년생)",
          "반려견 용이(♂, 치와와)",
        ],
        academics: [
          "초월초등학교 (졸업)",
          "광주중학교 (졸업)",
          "서울삼육고등학교 (졸업)",
        ],
        religion: "무종교",
        agency: "원헌드레드레이블",
        groupName: "더보이즈",
        position: "메인댄서, 서브보컬",
        debut: "2017년 더보이즈 미니 1집 THE FIRST",
        mbti: "ENTP",
        serialNumber: "11",
      },

      케빈: {
        name: "Kevin Moon (케빈 문), 문형서 (文炯書[훈음], Moon Hyungseo)",
        englishName: "Kevin",
        imgs: [
          "https://i.ibb.co/mq2QLYt/theboyz-kevin-slide1.png",
          "https://i.ibb.co/MVnjYq6/theboyz-kevin-slide2.png",
          "https://i.ibb.co/HT2vCCh/theboyz-kevin-slide3.png",
        ],
        birth: ["1998년 2월 23일", "광주광역시"],
        nationality: "캐나다",
        physical: "178cm | 60kg | 265mm | AB형",
        familys: ["부모님, 누나(1996년생)"],
        academics: [
          "Burnaby Mountain Secondary (졸업)",
          "브리티시 컬럼비아 대학교 (심리학 / 중퇴)",
        ],
        religion: "개신교",
        agency: "원헌드레드레이블",
        groupName: "더보이즈",
        position: "메인보컬",
        debut: "2017년 더보이즈 미니 1집 THE FIRST",
        mbti: "INFP",
        serialNumber: "16",
      },

      뉴: {
        name: "최찬희 (崔燦喜, Choi Chanhee)",
        englishName: "NEW",
        imgs: [
          "https://i.ibb.co/9yGb0G8/theboyz-new-slide1.png",
          "https://i.ibb.co/pnFr6Tv/theboyz-new-slide2.png",
          "https://i.ibb.co/Trsp3SZ/theboyz-new-slide3.png",
        ],
        birth: ["1998년 4월 26일", "전라북도 전주시 덕진구 송천동"],
        nationality: "대한민국",
        physical: "178cm | 250mm | B형",
        familys: ["부모님, 형(1988년생)"],
        academics: [
          "전주송원초등학교 (졸업)",
          "전주용소중학교 (졸업)",
          "완주고등학교 (졸업)",
        ],
        religion: "개신교",
        agency: "원헌드레드레이블",
        groupName: "더보이즈",
        position: "메인보컬",
        debut: "2017년 더보이즈 미니 1집 THE FIRST",
        mbti: "INFP",
        serialNumber: "98",
      },

      큐: {
        name: "지창민 (池昌珉, Ji Changmin)",
        englishName: "Q",
        imgs: [
          "https://i.ibb.co/PhcQNNx/theboyz-q-slide1.png",
          "https://i.ibb.co/zFg6R4V/theboyz-q-slide2.png",
          "https://i.ibb.co/1JyWrMP/theboyz-q-slide3.png",
        ],
        birth: ["1998년 11월 5일", "충청북도 청주시 흥덕구 개신동"],
        nationality: "대한민국",
        physical: "176cm | 55kg | 260~265mm | AB형",
        familys: ["아버지(1970년생), 어머니, 누나 2명", "반려견 가나(♂, 푸들)"],
        academics: [
          "청주개신초등학교 (졸업)",
          "성화중학교 (졸업)",
          "한국예술고등학교 (음악과 / 졸업)",
        ],
        religion: "개신교",
        agency: "원헌드레드레이블",
        groupName: "더보이즈",
        position: "메인댄서, 서브보컬",
        debut: "2017년 더보이즈 미니 1집 THE FIRST",
        mbti: "ISFP",
        serialNumber: "02",
      },
      주학년: {
        name: "주학년 (周鶴年, Ju Haknyeon), 周鶴年 (Zau¹ Hok⁶ Nin⁴, 자우혹닌)",
        englishName: "Ju Haknyeon",
        imgs: [
          "https://i.ibb.co/tm8TtBS/theboyz-jhn-slide1.png",
          "https://i.ibb.co/YW9KyBJ/theboyz-jhn-slide2.png",
          "https://i.ibb.co/sbJQJpJ/theboyz-jhn-slide3.png",
        ],
        birth: ["1999년 3월 9일", "제주도 남제주군 대정읍 동일리"],
        nationality: "대한민국",
        physical: "177cm | 58kg | 265mm | B형",
        familys: [
          "아버지(2016년 별세), 어머니, 누나(1996년생)",
          "여동생(2006년생), 반려견 까불",
        ],
        academics: [
          "대정서초등학교 (전학)",
          "대정초등학교 (졸업)",
          "대정중학교 (졸업)",
          "한림연예예술고등학교 (연예과 / 졸업)",
          "서울사이버대학교 (학과 불명 / 재학)",
        ],
        religion: "가톨릭 (세례명: 시몬)",
        agency: "원헌드레드레이블",
        groupName: "더보이즈",
        position: "서브보컬, 리드댄서",
        debut: "2017년 더보이즈 미니 1집 THE FIRST",
        mbti: "ENTJ",
        serialNumber: "09",
      },

      선우: {
        name: "김선우 (金善旴, Kim Sunwoo)",
        englishName: "Sunwoo",
        imgs: [
          "https://i.ibb.co/DkMZFrQ/theboyz-sw-slide1.png",
          "https://i.ibb.co/QjmXdhk/theboyz-sw-slide2.png",
          "https://i.ibb.co/J3jjr35/theboyz-sw-slide3.png",
        ],
        birth: ["2000년 4월 12일", "서울특별시 강남구 도곡동"],
        nationality: "대한민국",
        physical: "178cm | 61~62kg | 265~270mm | B형",
        familys: ["아버지(1974년생), 어머니(1980년생), 여동생(2002년생)"],
        academics: [
          "성남장안초등학교 (졸업)",
          "장안중학교 (전학)",
          "전의중학교 (전학)",
          "분진중학교 (졸업)",
          "한국예술고등학교 (미술과 / 전학)",
          "한림연예예술고등학교 (실용음악과 / 졸업)",
        ],
        religion: "무종교",
        agency: "원헌드레드레이블",
        groupName: "더보이즈",
        position: "메인래퍼, 서브보컬",
        debut: "2017년 더보이즈 미니 1집 THE FIRST",
        mbti: "ENTP",
        serialNumber: "19",
      },

      에릭: {
        name: "손영재 (孫英宰, Sohn Youngjae)",
        englishName: "Eric",
        imgs: [
          "https://i.ibb.co/jDvrRYZ/theboyz-eric-slide1.png",
          "https://i.ibb.co/8N8pdQd/theboyz-eric-slide2.png",
          "https://i.ibb.co/0YP0C2h/theboyz-erick-slide3.png",
        ],
        birth: ["2000년 12월 22일", "서울특별시 양천구 목동"],
        nationality: "대한민국",
        physical: "175cm | 60kg | 270mm | A형",
        familys: ["아버지, 어머니(1973년생), 누나(1999년생)"],
        academics: [
          "Northwood High School (전학)",
          "한국켄트외국인학교 (중등부 / 전학)",
          "부천부곡중학교 (졸업)",
          "서울공연예술고등학교 (실용무용과 / 졸업)",
        ],
        religion: "개신교",
        agency: "원헌드레드레이블",
        groupName: "더보이즈",
        position: "리드래퍼, 리드댄서, 서브보컬",
        debut: "2017년 더보이즈 미니 1집 THE FIRST",
        mbti: "ENFJ",
        serialNumber: "22",
      },
    },
    bgColor: "#000000",
    txtColor: "#FFFFFF",
    logo: "https://i.ibb.co/2dYdwQD/THEBOYZ-logo.png",
  },
  ZEROBASEONE: {
    members: {
      성한빈: {
        name: "성한빈 (成韓彬, Sung Hanbin)",
        englishName: "Sung Hanbin",
        imgs: [
          "https://i.ibb.co/Tr6cTkw/zb1-shb-slide1.png",
          "https://i.ibb.co/ZWj29St/zb1-shb-slide2.png",
          "https://i.ibb.co/zSPcskm/zb1-shb-slide3.png",
        ],
        birth: ["2001년 6월 13일", "충청남도 천안시 쌍용동"],
        nationality: "대한민국",
        physical: "179.6cm | 67kg | O형 | 270mm",
        familys: [
          "아버지 성현모, 어머니 한혜정",
          "여동생 성한아름(2005년생)",
          "반려견 보리(포메라니안), 관심(블랙탄 포메라니안)",
        ],
        academics: [
          "천안봉서초등학교 (졸업)",
          "천안계광중학교 (졸업)",
          "천안두정고등학교 (졸업)",
          "동아방송예술대학교 (방송연예계열 K-POP전공)",
        ],
        religion: "천주교 (세례명: 안토니오) → 무종교",
        agency: "THE L1VE LABEL, STUDIO GL1DE, 웨이크원",
        groupName: "ZEROBASEONE",
        position: "리더, 보컬, 댄스",
        debut: "2023년 7월 10일 ZEROBASEONE 미니 1집 YOUTH IN THE SHADE",
        mbti: "ENFJ",
      },

      김지웅: {
        name: "김지웅 (金地雄, Kim Jiwoong)",
        englishName: "Jiwoong",
        imgs: [
          "https://i.ibb.co/Hp9dGS3/zb1-kjw-slide1.png",
          "https://i.ibb.co/cbXmPWQ/zb1-kjw-slide2.png",
          "https://i.ibb.co/JHDfTCx/zb1-kjw-slide3.png",
        ],
        birth: ["1998년 12월 14일", "경상북도 포항시"],
        nationality: "대한민국",
        physical: "181cm | AB형 | 270mm",
        familys: ["부모님, 형(1997년생), 남동생(2008년생)"],
        academics: ["평원중학교 (졸업)", "방송통신고등학교 (졸업)"],
        agency: "네스트매니지먼트, 웨이크원",
        groupName: "ZEROBASEONE",
        position: "보컬, 래퍼",
        debut: "2023년 7월 10일 ZEROBASEONE",
        mbti: "ENFJ",
      },

      장하오: {
        name: "장하오 (章昊, Zhāng Hào)",
        englishName: "Zhang Hao",
        imgs: [
          "https://i.ibb.co/kG6tPbP/zb1-zhao-slide1.png",
          "https://i.ibb.co/tCDFXWn/zb1-zhao-slide2.png",
          "https://i.ibb.co/2dBFBq4/zb1-zhao-slide3.png",
        ],
        birth: ["2000년 7월 25일", "푸젠성 난핑시"],
        nationality: "중국",
        physical: "180.5cm | A형 | 270mm",
        familys: ["부모님", "반려견 바오바오(푸들), 니우니우"],
        academics: [
          "중국지질대학 (지질학 / 중퇴)",
          "푸젠사범대학 (음악교육학 / 학사)",
        ],
        religion: "무종교",
        agency: "위에화엔터테인먼트코리아, 웨이크원",
        groupName: "ZEROBASEONE",
        position: "센터, 보컬, 댄서",
        debut: "2023년 7월 10일 ZEROBASEONE",
        mbti: "ISFP",
      },

      석매튜: {
        name: [
          "Matthew Woohyun Seok (매튜 우현 석)",
          "석우현 (石友鉉, Seok Woohyun)",
        ],
        englishName: "Matthew",
        imgs: [
          "https://i.ibb.co/g65BG65/zb1-smattew-slide1.png",
          " https://i.ibb.co/85Cwz59/zb1-smattew-slide2.png",
          "https://i.ibb.co/7pNxzYJ/zb1-smattew-slide3.png",
        ],
        birth: ["2002년 5월 28일", "브리티시컬럼비아 밴쿠버"],
        nationality: "캐나다",
        physical: "170cm | B형 | 270mm",
        familys: [
          "부모님, 누나 Yaebin Seok(1998년생)",
          "반려견 테디, 뭉치(말티즈)",
        ],
        academics: [
          "Earl Marriott Secondary School (졸업)",
          "웨스턴 대학교 (보건학 / 중퇴)",
        ],
        religion: "천주교 (세례명: 매튜)",
        agency: "MNH엔터테인먼트, 웨이크원",
        groupName: "ZEROBASEONE",
        position: "보컬, 래퍼, 댄서",
        debut: "2023년 7월 10일 ZEROBASEONE",
        mbti: "ENFJ",
      },

      김태래: {
        name: "김태래 (金泰來, Kim Taerae)",
        englishName: "Taerae",
        imgs: [
          "https://i.ibb.co/S3jV0pN/zb1-ktr-slide1.png",
          "https://i.ibb.co/zJx1TW5/zb1-ktr-slide2.png",
          "https://i.ibb.co/gj4qS6H/zb1-ktr-slide3.png",
        ],
        birth: ["2002년 7월 14일", "충청남도 천안시 동남구"],
        nationality: "대한민국",
        physical: "174cm | O형 | 280mm",
        familys: ["부모님, 누나(1994년생)"],
        academics: [
          "신흥초등학교 (졸업 / 8회)",
          "천안동중학교 (졸업 / 32회)",
          "천안쌍용고등학교 (졸업 / 15회)",
          "용인대학교 문화예술대학 (실용음악과 / 중퇴)",
          "서울사이버대학교 (재학)",
        ],
        agency: "웨이크원",
        groupName: "ZEROBASEONE",
        position: "메인보컬",
        debut: "2023년 7월 10일 ZEROBASEONE",
        mbti: "ESTJ",
      },

      리키: {
        name: "션취안루이 (沈泉锐, Shěn Quánruì)",
        englishName: "Ricky",
        imgs: [
          "https://i.ibb.co/ByrYGTw/zb1-ricky-slide1.png",
          "https://i.ibb.co/GV7h7WT/zb1-ricky-slide2.png",
          "https://i.ibb.co/44R6fkt/zb1-ricky-slide3.png",
        ],
        birth: ["2004년 5월 20일", "상하이시"],
        nationality: "중국",
        physical: "184.4cm | A형 | 285~290mm",
        familys: ["부모님, 여동생(2009년생)"],
        academics: [
          "Shanghai United International School (중퇴)",
          "Orange County School of the Arts (미술과 / 중퇴)",
        ],
        agency: "위에화엔터테인먼트코리아, 웨이크원",
        groupName: "ZEROBASEONE",
        position: "보컬",
        debut: "2023년 7월 10일 ZEROBASEONE",
        mbti: "INTP",
      },

      김규빈: {
        name: "김규빈 (金奎彬, Kim Gyuvin)",
        englishName: "Gyuvin",
        imgs: [
          "https://i.ibb.co/xLYHNJt/zb1-kgv-slide1.png",
          "https://i.ibb.co/zxZY3N4/zb1-kgv-slide2.png",
          "https://i.ibb.co/2N3Dw6B/zb1-kgv-slide3.png",
        ],
        birth: ["2004년 8월 30일", "서울특별시 강남구 압구정동"],
        nationality: "대한민국",
        physical: "188cm | 63kg | B형 | 285~290mm",
        familys: [
          "부모님, 첫째 남동생 김규민(2007년생)",
          "둘째 남동생 김규완(2008년생)",
          "여동생 김규리(2010년 11월 30일생)",
          "반려견 음빠빠(이탈리안 그레이하운드, 5월 16일생)",
        ],
        academics: [
          "압구정 위즈아일랜드 영어유치원 (졸업)",
          "서울압구정초등학교 (졸업)",
          "압구정중학교 (졸업)",
          "압구정고등학교 (졸업)",
        ],
        agency: "위에화엔터테인먼트코리아, 웨이크원",
        groupName: "ZEROBASEONE",
        position: "보컬, 래퍼",
        debut: "2023년 7월 10일 ZEROBASEONE",
        mbti: "ENFP",
      },
      박건욱: {
        name: "박건욱 (朴乾旭, Park Gunwook)",
        englishName: "Gunwook",
        imgs: [
          "https://i.ibb.co/85VSPpD/zb1-pgw-slide1.png",
          "https://i.ibb.co/02yg6Zm/zb1-pgw-slide2.png",
          "https://i.ibb.co/FVZdz4p/zb1-pgw-slide3.png",
        ],
        birth: ["2005년 1월 10일", "경기도 오산시 가수동"],
        nationality: "대한민국",
        physical: "183.9cm | 73kg | 280mm",
        familys: ["부모님, 형 박찬욱(2001년생)"],
        academics: [
          "오산초등학교 (졸업)",
          "오산중학교 (졸업)",
          "오산정보고등학교 (졸업)",
        ],
        religion: "천주교",
        agency: "젤리피쉬엔터테인먼트, 웨이크원",
        groupName: "ZEROBASEONE",
        position: "보컬, 래퍼, 댄서",
        debut: "2023년 7월 10일 ZEROBASEONE",
        mbti: "ENFJ",
      },

      한유진: {
        name: "한유진 (韓維辰, Han Yujin)",
        englishName: "Yujin",
        imgs: [
          "https://i.ibb.co/6FTSz21/zb1-hyj-slide1.png",
          "https://i.ibb.co/PZ1RG2S/zb1-hyj-slide2.png",
          "https://i.ibb.co/f9fphc1/zb1-hyj-slide3.png",
        ],
        birth: ["2007년 3월 20일", "대구광역시"],
        nationality: "대한민국",
        physical: "176cm | A형 | 270mm",
        familys: ["부모님, 여동생"],
        academics: [
          "산의초등학교 (전학)",
          "성복초등학교 (졸업)",
          "성복중학교 (졸업)",
          "한림연예예술고등학교 (실용무용과 / 재학)",
        ],
        agency: "웨이크원",
        groupName: "ZEROBASEONE",
        position: "보컬, 래퍼, 댄서",
        debut: "2023년 7월 10일 ZEROBASEONE",
        religion: "천주교 (세례명 : 카이)",
        mbti: "INTJ",
      },
    },
    bgColor: "#4965C7",
    txtColor: "#FFFFFF",
    logo: "https://i.ibb.co/BNFgCgJ/zb1-logo.png",
  },
  RIIZE: {
    members: {
      쇼타로: {
        name: "오사키 쇼타로 (大﨑 将太た郎, Osaki Shotaro)",
        englishName: "Shotaro",
        imgs: [
          "https://i.ibb.co/pr6p1nm/riize-sho-slide1.png",
          "https://i.ibb.co/LtjGdry/riize-sho-slide2.png",
          "https://i.ibb.co/DLd503r/riize-sho-slide3.png",
        ],
        birth: ["2000년 11월 25일", "가나가와현 요코하마시"],
        nationality: "일본",
        physical: "178cm | 62~63kg | A형 | 280mm",
        familys: [
          "아버지 오사키 켄타로(8월 24일생), 어머니",
          "여동생(2005년생), 남동생(2012년생)",
          "반려견 초코",
        ],
        academics: ["대학교 (경제학 / 중퇴)"],
        agency: "SM엔터테인먼트",
        groupName: "RIIZE",
        position: "댄서, 래퍼",
        debut: "2023년 9월 4일 RIIZE 싱글 1집 Get A Guitar",
        mbti: "ESFP",
      },

      은석: {
        name: "송은석 (宋恩奭, Song Eunseok)",
        englishName: "Eunseok",
        imgs: [
          "https://i.ibb.co/rvyk1bN/riize-es-slide1.png",
          "https://i.ibb.co/kKxBVhc/riize-es-slide2.png",
          "https://i.ibb.co/R2FtRVs/riize-es-slide3.png",
        ],
        birth: ["2001년 3월 19일", "서울특별시 광진구 구의동"],
        nationality: "대한민국",
        physical: "180cm | 59~60kg | AB형 | 260mm",
        familys: [
          "아버지 송요한, 어머니, 남동생(2015년생)",
          "반려견 찰리(2021년생, ♂, 화이트 푸들)",
        ],
        academics: [
          "서울구남초등학교 (졸업)",
          "광진중학교 (졸업)",
          "광남고등학교 (중퇴)",
        ],
        religion: "개신교",
        agency: "SM엔터테인먼트",
        groupName: "RIIZE",
        position: "보컬",
        debut: "2023년 9월 4일 RIIZE 싱글 1집 Get A Guitar",
        mbti: "ISTP",
      },

      성찬: {
        name: "정성찬 (鄭成燦, Jung Sungchan)",
        englishName: "Sungchan",
        imgs: [
          "https://i.ibb.co/p1ns7SK/riize-sc-slide1.png",
          "https://i.ibb.co/2cQb5zQ/riize-sc-slide2.png",
          "https://i.ibb.co/Qvsk70W/riize-sc-slide3.png",
        ],
        birth: ["2001년 9월 13일", "서울특별시 강남구 개포동"],
        nationality: "대한민국",
        physical: "185.6cm | 71~72kg | A형 | 270mm",
        familys: [
          "아버지 정석주, 어머니, 형(1999년생)",
          "반려견 겨울(♀, 말티즈)",
        ],
        academics: [
          "서울구룡초등학교 (졸업)",
          "언북중학교 (졸업)",
          "청담고등학교 (중퇴)",
          "고등학교 졸업 학력 검정고시 (합격)",
        ],
        agency: "SM엔터테인먼트",
        groupName: "RIIZE",
        position: "래퍼",
        debut: "2023년 9월 4일 RIIZE 싱글 1집 Get A Guitar",
        mbti: "ESTP",
      },

      원빈: {
        name: "박원빈 (朴元彬, Park Wonbin)",
        englishName: "Wonbin",
        imgs: [
          "https://i.ibb.co/MsSCWX1/riize-wb-slide1.png",
          "https://i.ibb.co/5rKTh1k/riize-wb-slide2.png",
          "https://i.ibb.co/RSLFwr0/riize-wb-slide3.png",
        ],
        birth: ["2002년 3월 2일", "서울특별시 성북구"],
        nationality: "대한민국",
        physical: "176cm | 59kg | AB형 | 270mm",
        familys: ["아버지 박광훈, 어머니, 형(2000년생)"],
        academics: [
          "천상초등학교 (졸업)",
          "울산스포츠과학중학교 (전학)",
          "천상중학교 (졸업)",
          "울산상업고등학교 (중퇴)",
        ],
        religion: "무종교",
        agency: "SM엔터테인먼트",
        groupName: "RIIZE",
        position: "센터, 보컬, 댄서",
        debut: "2023년 9월 4일 RIIZE 싱글 1집 Get A Guitar",
        mbti: "INFJ",
      },

      소희: {
        name: "이소희 (李炤煕, Lee Sohee)",
        englishName: "Sohee",
        imgs: [
          "https://i.ibb.co/hd42PGT/riize-sh-slide1.png",
          "https://i.ibb.co/MsddFjf/riize-sh-slide2.png",
          "https://i.ibb.co/BV6xPsh/riize-sh-slide3.png",
        ],
        birth: ["2003년 11월 21일", "경기도 시흥시 능곡동"],
        nationality: "대한민국",
        physical: "174cm | 54~55kg | A형 | 265mm",
        familys: [
          "아버지 이형민, 어머니(1976년생)",
          "누나 2명(1999년생, 2001년생)",
        ],
        academics: [
          "시흥능곡초등학교 (졸업)",
          "시흥능곡중학교 (졸업)",
          "시흥능곡고등학교 (졸업)",
        ],
        agency: "SM엔터테인먼트",
        groupName: "RIIZE",
        position: "메인보컬",
        debut: "2023년 9월 4일 RIIZE 싱글 1집 Get A Guitar",
        mbti: "ISTP",
      },

      앤톤: {
        name: [
          "앤톤 찬영 리 (Anton Chanyoung Lee)",
          "이찬영 (李燦榮, Lee Chanyoung)",
        ],
        englishName: "Anton",
        imgs: [
          "https://i.ibb.co/wRBRjWq/riize-anton-slide1.png",
          "https://i.ibb.co/jgJh7hc/riize-anton-slide2.png",
          "https://i.ibb.co/bgtVNSC/riize-anton-slide3.png",
        ],
        birth: ["2004년 3월 21일", "매사추세츠 주 보스턴"],
        nationality: "대한민국, 미국 (복수국적)",
        physical: "184cm | 65kg | O형",
        familys: [
          "아버지 윤상, 어머니 심혜진",
          "남동생 이준영(2009년 6월 30일생)",
          "반려견 코코, 메이",
        ],
        academics: [
          "Dwight-Englewood School (중퇴)",
          "고등학교 졸업 학력 검정고시",
          "GED(합격, 알려지지않음)",
        ],
        agency: "SM엔터테인먼트",
        groupName: "RIIZE",
        position: "보컬",
        debut: "2023년 9월 4일 RIIZE 싱글 1집 Get A Guitar",
        mbti: "INTP",
      },
    },
    bgColor: "#F0A240",
    txtColor: "#000000",
    logo: "https://i.ibb.co/S364BVb/riize-logo.png",
  },
  NCTWISH: {
    members: {
      시온: {
        name: "오시온 (吳是溫, Oh Sion, オ·シオン)",
        englishName: "Sion",
        imgs: [
          "https://i.ibb.co/tq2fTBb/nctwish-sion-slide1.png",
          "https://i.ibb.co/D48MS5K/nctwish-sion-slide2.png",
          "https://i.ibb.co/cQTRMN1/nctwish-sion-slide3.png",
        ],
        birth: ["2002년 5월 11일", "전라남도 목포시 상동 목포한사랑병원"],
        nationality: "대한민국",
        physical: "179cm | O형 | 255mm",
        familys: ["부모님, 여동생(2004년생)", "반려견 코코(비숑 프리제)"],
        academics: ["목포애향중학교 (졸업)", "목포마리아회고등학교 (중퇴)"],
        religion: "무종교",
        agency: "SM엔터테인먼트",
        groupName: "NCT, NCT WISH",
        position: "리더, 메인댄서, 리드보컬",
        debut: "2024년 NCT WISH 싱글 1집 WISH",
        mbti: "INTJ",
        symbolNumber: "01",
      },
      리쿠: {
        name: "前田 陸 (마에다 리쿠, Riku Maeda)",
        englishName: "Riku Maeda",
        imgs: [
          "https://i.ibb.co/RSYbcy3/nctwish-riku-slide1.png",
          "https://i.ibb.co/b57gPN9/nctwish-riku-slide2.png",
          "https://i.ibb.co/mtgQPdQ/nctwish-riku-slide3.png",
        ],
        birth: ["2003년 6월 28일", "후쿠이현"],
        nationality: "일본",
        physical: "175cm | AB형 | 280mm",
        familys: ["부모님, 누나 2명(1998년생, 2001년생)"],
        agency: "SM엔터테인먼트",
        groupName: "NCT, NCT WISH",
        position: "메인래퍼, 리드댄서 (NCT WISH)",
        debut: "2024년 NCT WISH 싱글 1집 WISH",
        mbti: "ISFP",
        symbolNumber: "03",
      },
      유우시: {
        name: "得能 勇志 (토쿠노 유우시, Yūshi Tokuno)",
        englishName: "Yūshi Tokuno",
        imgs: [
          "https://i.ibb.co/vjTL8ZL/nctwish-yushi-slide1.png",
          "https://i.ibb.co/wsZh6ZZ/nctwish-yushi-slide2.png",
          "https://i.ibb.co/G27WwPS/nctwish-yushi-slide3.png",
        ],
        birth: ["2004년 4월 5일", "도쿄도 고토구"],
        nationality: "일본",
        physical: "175cm | A형 | 265mm",
        familys: ["부모님, 남동생 토쿠노 지우(2010년생)"],
        academics: [
          "고토구립 도요스키타 초등학교 (졸업)",
          "고토구립 후카가와 다이고 중학교 (졸업)",
        ],
        agency: "SM엔터테인먼트",
        groupName: "NCT, NCT WISH",
        position: "메인댄서, 리드보컬",
        debut: "2024년 NCT WISH 싱글 1집 WISH",
        mbti: "ISFJ",
        symbolNumber: "45",
      },
      재희: {
        name: "김대영 (金垈永, Kim Daeyoung, キム·デヨン)",
        englishName: "JAEHEE",
        imgs: [
          "https://i.ibb.co/hR1H87r/nctwish-jh-slide1.png",
          "https://i.ibb.co/jHG11jx/nctwish-jh-slide2.png",
          "https://i.ibb.co/rmRH3N5/nctwish-jh-slide3.png",
        ],
        birth: ["2005년 6월 21일", "대구광역시 달서구 장기동"],
        nationality: "대한민국",
        physical: "185cm | 65kg | O형",
        familys: ["부모님, 형 2명(1994년생, 1998년생)"],
        academics: [
          "대구장동초등학교 (졸업)",
          "효성중학교 (졸업)",
          "영남고등학교 (중퇴)",
        ],
        agency: "SM엔터테인먼트",
        groupName: "NCT, NCT WISH",
        position: "메인보컬",
        debut: "2024년 NCT WISH 싱글 1집 WISH",
        mbti: "ENFP",
        symbolNumber: "13",
      },
      료: {
        name: "廣瀬 遼 (히로세 료, Ryo Hirose)",
        englishName: "Ryo Hirose",
        imgs: [
          "https://i.ibb.co/t3jfCvS/nctwish-ryo-slide1.png",
          "https://i.ibb.co/mCk7SWg/nctwish-ryo-slide2.png",
          "https://i.ibb.co/F8Z9Q5k/nctwish-ryo-slide3.png",
        ],
        birth: ["2007년 8월 4일", "교토부"],
        nationality: "일본",
        physical: "A형 | 260mm",
        familys: ["부모님, 누나(2004년생)"],
        academics: ["노트르담 학원 초등학교 (졸업)"],
        agency: "SM엔터테인먼트",
        groupName: "NCT, NCT WISH",
        position: "서브보컬, 서브댄서",
        debut: "2024년 NCT WISH 싱글 1집 WISH",
        mbti: "ENTP",
        symbolNumber: "21",
      },
      사쿠야: {
        name: "藤永 咲哉 (후지나가 사쿠야, Sakuya Fujinaga)",
        englishName: "Sakuya Fujinaga",
        imgs: [
          "https://i.ibb.co/2hJvHdK/nctwish-sakuya-slide1.png",
          "https://i.ibb.co/ZSGTcvj/nctwish-sakuya-slide2.png",
          "https://i.ibb.co/8zQ696W/nctwish-sakuya-slide3.png",
        ],
        birth: ["2007년 11월 18일", "이시카와현"],
        nationality: "일본",
        physical: "175cm | AB형",
        familys: ["부모님, 여동생"],
        agency: "SM엔터테인먼트",
        groupName: "NCT, NCT WISH",
        position: "리드래퍼, 서브보컬",
        debut: "2024년 NCT WISH 싱글 1집 WISH",
        mbti: "ENFP",
        symbolNumber: "39",
      },
    },
    bgColor: "#B5E1FD",
    txtColor: "#000000",
    logo: "https://i.ibb.co/GHFSF8j/nctwish-logo.png",
  },
};
